<div class="success">
  <i class="fa fa-check-circle fa-4x" style="margin-bottom: 10px; color: green"></i>
  <span>{{data?.message || 'Sin Mensaje'}}</span>
</div>
